import {useToNumber, useCheckType, types} from '@sttedra_ui/framework';

class BaseApiModel {
  // #region Props
  id;
  // #endregion


  constructor({
    id,
  }) {
    this.id = this.#getNumber(id);
    if (!this.id) { // String if not number
      this.id = this.#getString(id);
    }
  }


  // #region Private methods
  #getNumber(newValue) {
    const number = useToNumber(newValue);
    return number >= 0 ? number : null;
  }
  #getString(newValue) {
    const expectedType = useCheckType(newValue, types.STRING);
    return expectedType ? newValue : null;
  }
  // #endregion
}

export default BaseApiModel;
